<!-- Container -->
<div class="kt-container-fixed">
	<div class="flex flex-col items-center justify-center gap-3 py-5 md:flex-row md:justify-between">
		<div class="order-2 flex gap-2 text-sm font-normal md:order-1">
			<span class="text-muted-foreground">
				2025©
			</span>
			<a class="hover:text-primary text-secondary-foreground" href="https://keenthemes.com">
				Keenthemes Inc.
			</a>
		</div>
		<nav class="order-1 flex gap-4 text-sm font-normal text-secondary-foreground md:order-2">
			<a class="hover:text-primary" href="https://keenthemes.com/metronic/tailwind/docs">
				Docs
			</a>
			<a class="hover:text-primary" href="https://1.envato.market/Vm7VRE">
				Purchase
			</a>
			<a class="hover:text-primary" href="https://keenthemes.com/metronic/tailwind/docs/getting-started/license">
				FAQ
			</a>
			<a class="hover:text-primary" href="https://devs.keenthemes.com">
				Support
			</a>
			<a class="hover:text-primary" href="https://keenthemes.com/metronic/tailwind/docs/getting-started/license">
				License
			</a>
		</nav>
	</div>
</div>
<!-- End of Container -->